
import React, { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';
import { checkPointsInPolygons } from './LinePolygons';
import { groupMarkersByVetka, groupMarkersByCanton } from '../TerritoryFilter/GroupMarkersPolygon';

const LinkEditingCanton = ({ polylinePoints, setPolylinePoints, editMode, setLengthCableEditing, setLineEditing, switchesData = [], selectedCanton, housesData,
  polyline, setPolyline
 }) => {


  const map = useMap();



   const markersByVetka = groupMarkersByVetka(housesData);
   const markersByCanton = groupMarkersByCanton(switchesData);

  useEffect(() => {
    if (!map) return;
  
    const customMarker = L.divIcon({
      className: 'custom-edit-icon', 
    });
  
    const newPolyline = L.polyline(polylinePoints, { color: 'grey' }).addTo(map);
    setPolyline(newPolyline);
  
    if (editMode) {
      const drawnItems = new L.FeatureGroup([newPolyline]);
      map.addLayer(drawnItems);
  
      newPolyline.on('edit', (e) => {
        const newLatLngs = e.target.getLatLngs();
        const newPoints = newLatLngs.map((latlng) => [latlng.lat, latlng.lng]);
        setPolylinePoints(newPoints);
  
        const distances = [];
        let totalLength = 0;
  
        newLatLngs.forEach((latLng, i) => {
          const LengthSegment = i < newLatLngs.length - 1 ? Math.round(latLng.distanceTo(newLatLngs[i + 1])) : 0;
          totalLength += LengthSegment;
  
          const result = checkPointsInPolygons([{ lat: latLng.lat, lng: latLng.lng }], markersByCanton, markersByVetka, selectedCanton)[0];
  
          if (result) {
            distances.push({
              LengthSegment,
              Latitude: latLng.lat,
              Longitude: latLng.lng,
              PolygonInfo: result.polygonInfo,
              FlagTerritory: result.flagTerritory
            });
          } else {
            console.warn('Invalid point returned from checkPointsInPolygons');
          }
        });
  
        setLengthCableEditing(totalLength);
        setLineEditing(distances);
      });
  
      newPolyline.editing.enable();
      newPolyline.editing.options.editIcon = customMarker; 
    }
  
    return () => {
      map.removeLayer(newPolyline);
    };
  }, [map, polylinePoints, setPolylinePoints, editMode]);

  useEffect(() => {
    if (polyline) {
      if (editMode) {
        polyline.editing.enable();
      } else {
        polyline.editing.disable();
      }
    }
  }, [editMode, polyline]);

  return null;
};

export default LinkEditingCanton;
